export enum EpiFragmentType {
    Static = "Static",
    Url = "Url",
    EmbeddedContent = "EmbeddedContent",
    Image = "Image",
}
